import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function ExpedientePrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Expediente'} />

      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDADG'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Departamento Apoio ao Director Geral'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDCITMS'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Departamento de Comunição e Inovação Tecnológica e Modernização de Serviços'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDASG'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Departamento Administração e Serviços Gerais'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDCQMTS'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Departamento Controlo de qualidade de Medicamentos e Tecnologias de Saúde'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDFTEC'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Departamento Farmacovigilância, Tecnovigilância e Ensaios Clínicos'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDLIF'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Departamento Licenciamento e Inspecção Farmacêutica'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDMTS'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Departamento Medicamentos e Tecnologias de Saúde'}
                  descricao={''}
                />
              , editable: false,
            },

          ]
        } />


      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteLicenciamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'LICENCIAMENTO'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteProdutoControlado'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'PRODUTO CONTROLADO'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteImportacao'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'IMPORTAÇÃO'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteDesalfandegamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'DESALFANDEGAMENTO'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteControloQualidade'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'CONTROLO DE QUALIDADE'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteFarmacovigilancia'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'FARMACOVIGILÂNCIA'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'expedienteMedicamentos'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'MEDICAMENTOS'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoesExpediente'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Reclamações do Expediente'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
